import React, {Component} from "react";
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import cvSrc from '../../../assets/docs/SaiTejaMalladi.pdf';
import {Button} from '@material-ui/core';
import classes from './Header.module.css';
import Menu from "../../Menu/Menu";
import profileData from '../../../assets/static/profile.json';

class Header extends Component {
	render() {
		let profile = profileData.profile;
		return (
			<header className={classes.Header}>
				<div className={classes.HeaderContent}>
					<div className={classes.HeaderPhoto}>
						<img src={profile.pic} alt={profile.name}/>
					</div>
					<div className={classes.HeaderTitles}>
						<h2>{profile.name}</h2>
						<h4>Full Stack Developer</h4>
					</div>
				</div>
				<div className={classes.Menu}>
					<Menu/>
				</div>
				<div className={classes.SocialLinks}>
					<ul>
						{/* eslint-disable-next-line react/jsx-no-target-blank */}
						<li><a target="_blank" href={profile.linkedin}><LinkedInIcon /></a></li>
						{/* eslint-disable-next-line react/jsx-no-target-blank */}
						<li><a target="_blank" href={profile.github}><GitHubIcon /></a></li>
						{/* eslint-disable-next-line react/jsx-no-target-blank */}
						<li><a target="_blank" href={profile.facebook}><FacebookIcon /></a></li>
					</ul>
				</div>
				<div className={classes.HeaderButtons}>
					<Button variant="contained" color="default" className={classes.Button}>
						<a href={cvSrc} download>Download CV</a>
					</Button>
				</div>
			</header>
		);
	}
}

export default Header;